import React from 'react';
import styles from './Separator.module.scss';

import clsx from 'clsx';

export default function Separator({ classes }) {
  return <div className={clsx(classes && classes, styles.separator)}></div>;
}
